<template>
  <div class="page-container">
    <ProductsLocationsModal />
    <ProductsGalleryModal />
    <ProductsListFilter />
    <ProductFormModal />
    <ProductsList />
  </div>
</template>

<script>
import ProductsLocationsModal from "@/components/dashboard/ProductsLocationsModal.vue";
import ProductsGalleryModal from "@/components/dashboard/ProductsGalleryModal.vue";
import ProductsListFilter from "@/components/dashboard/ProductsListFilter.vue";
import ProductFormModal from "@/components/dashboard/ProductFormModal.vue";
import ProductsList from "@/components/dashboard/ProductsList.vue";

export default {
  name: "Dashboard",
  components: {
    ProductsLocationsModal,
    ProductsGalleryModal,
    ProductsListFilter,
    ProductFormModal,
    ProductsList,
  },
};
</script>
